import * as React from 'react'
import classNames from 'classnames'

interface Props {
    downloadUrl: string
    slot?: string
    tile?: boolean
}

export function VideoFileGuide(props: Props) {
    const classes = classNames({
        'AppCore__guide__VideoFileGuide-video': true,
        'AppCore__guide__VideoFileGuide-video--tile': props.tile,
    })
    return (
        <video className={classes} controls loop preload="auto" playsInline slot={props.slot}>
            <source src={props.downloadUrl} />
        </video>
    )
}
